import type { ReactNode } from 'react';
import type { RbacPermission } from '@digitaltattoo/types';
import { Navigate } from 'react-router-dom';
import { useRbac } from '../contexts/RbacContext';

export function PermissionRoute({
  permission,
  children,
}: {
  permission: RbacPermission;
  children: ReactNode;
}) {
  const { can, loading } = useRbac();

  if (loading) {
    return <div className="p-6 text-sm text-gray-500">Vérification des permissions…</div>;
  }
  if (!can(permission)) {
    return <Navigate to="/dashboard" replace />;
  }
  return <>{children}</>;
}

export default PermissionRoute;
